var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebScraping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.039,
    height: 12.869,
    viewBox: "0 0 14.039 12.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(0 -21.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M12.284,21.333H1.755A1.757,1.757,0,0,0,0,23.088v9.359A1.757,1.757,0,0,0,1.755,34.2H12.284a1.757,1.757,0,0,0,1.755-1.755V23.088A1.757,1.757,0,0,0,12.284,21.333Zm-8.359,11.7H2.755a.585.585,0,0,1,0-1.17h1.17a.585.585,0,0,1,0,1.17Zm3.68,0H6.434a.585.585,0,1,1,0-1.17H7.6a.585.585,0,1,1,0,1.17Zm3.68,0h-1.17a.585.585,0,0,1,0-1.17h1.17a.585.585,0,0,1,0,1.17Zm1.585-2.34H1.17v-7.6a.586.586,0,0,1,.585-.585H12.284a.586.586,0,0,1,.585.585Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582",
    transform: "translate(1.984 23.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M95.036,114.382a6.283,6.283,0,0,0-4.957,2.763.4.4,0,0,0,0,.476,5.827,5.827,0,0,0,9.913,0,.4.4,0,0,0,0-.476A6.279,6.279,0,0,0,95.036,114.382Zm.138,5.115a2.118,2.118,0,1,1,1.976-1.976A2.119,2.119,0,0,1,95.174,119.5Zm-.064-.977a1.141,1.141,0,1,1,1.065-1.065A1.139,1.139,0,0,1,95.11,118.521Z",
    transform: "translate(-90 -114.382)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebScraping);
export default __webpack_public_path__ + "static/media/web_scraping.16fdbfc3ca990b0b219a85f4b4b5922a.svg";
export { ForwardRef as ReactComponent };